<template>
<div class="message_container">
    <div class="message__parent">
        <div class="message__filter">
            <b-checkbox v-model="messageFilterRead" :indeterminate="getMessageReadStatus">
                {{ checkboxReadLabel }} (All)
            </b-checkbox>

            <b-checkbox v-model="messageFilterUnread" >
                {{ messageFilterUnread ? 'Showing unread messages' : 'Showing all messages' }} (Yours)
            </b-checkbox>

            <b-field style="margin-bottom: 20px;">
                <b-input icon="magnify" placeholder="Filter messages" v-model="messageFilters.filterText"></b-input>
            </b-field>
        </div>

        <div class="message-holder" v-for="(category, index) in menuCategories" :key="index">
            <p class="message-holder__header">{{ category }}</p>
            <div class="message-holder__body" v-for="(message, messageIndex) in getMessageByCategory(category)" :key="messageIndex" @click.prevent="showUpdates(message)" :class="isMessageUnread(message)">
                <p class="mess_body" :title="message.courseTitle"> {{ message.courseTitle }} </p>
                <p class="mess_body" :title="message.studentName">{{ message.studentName }}</p>
                <p class="mess_body" :title="message.advisorName">{{ message.advisorName }}
                    <b-icon title="Mark as seen" style="cursor: pointer;" icon="check-all" :type="message.isUnread ? 'is-danger' : 'is-success'" size="is-small"></b-icon>
                </p>
            </div>
            <div v-if="countCategories(category)">
                No messages found for this period
            </div>
        </div>

        <footer class="message__footer">
            {{ countUnreadMesssages() }}
        </footer>
    </div>

    <div v-if="isMessageModalActive" class="message-modal">
        <student-message />
    </div>

    <div v-else class="message-modal__empty">
        <img src="https://media-public.canva.com/fkttc/MAEkGnfkttc/1/t.png" alt="">
        <p>Click a mesage to read</p>
    </div>
</div>
</template>

<script>
import StudentMessage from './StudentMessage.vue';
import moment from 'moment'
import UtilService from '../../services/util'
import StudentService from "../../services/student.service";
export default {
    name: "Messaging",
    components: {
        StudentMessage
    },
    data() {
        return {
            copyMessages: [],
            
            isMessageModalActive: false,
            menuCategories: ['Today', 'Yesterday', 'Last Week', 'Older'],
            menuCategoriesCount: {},
            messageFilters: {
                filterMessageReadBy: null,
                filterUnread: false,
                filterText: ''
            }
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        storedMessages() {
            return this.$store.state.message.appMessages
        },
        getActiveConversation() {
            return UtilService.getActiveConversation()
        },
        getMessagesForConversation() {
            return this.sortedMessages(UtilService.getMessagesForConversation())
        },
        messageFilterUnread: {
            get() {
                return this.messageFilters.filterUnread
            },
            set(value) {
                setTimeout(() => {
                    this.messageFilters.filterUnread = value
                }, 0);
            }
        },
        messageFilterRead: {
            get() {
                return this.messageFilters.filterMessageReadBy
            },
            set(value) {
                const valueToChange = value === true && this.messageFilters.filterMessageReadBy === false ? null : value
                setTimeout(() => {
                    this.messageFilters.filterMessageReadBy = valueToChange
                }, 0);
            }
        },
        checkboxReadLabel() {
            return this.messageFilters.filterMessageReadBy === null ? 'Showing all messages' :
            this.messageFilters.filterMessageReadBy === true ? 'Showing read messages' :
                'Showing unread messages'
        },

        getMessageReadStatus() {
            return this.messageFilters.filterMessageReadBy === null
        },
        appMessages() {
            const messageFilters = this.messageFilters
            const courseMapModerator = this.$store.state.application.courseMapModerator
            const invites = this.$store.state.message.invites
            const currentUserId  = this.currentUser.id;

            function filterTextMessages(message) {
                const filteredText = messageFilters.filterText.toLowerCase().replace(/ /g, '')
                return filteredText.length && message.advisorName && message.courseTitle && message.moderatorName ? message.advisorName.toLowerCase().replace(/ /g, '').includes(filteredText) ||
                    message.courseTitle.toLowerCase().replace(/ /g, '').includes(filteredText) ||
                    message.moderatorName.toLowerCase().replace(/ /g, '').includes(filteredText) : true;
            }

            function filterUnreadMessages(message) {
                return messageFilters.filterUnread ? (courseMapModerator.filter(course => course.title === message.courseTitle && course.moderatorId.includes(currentUserId)).length ||
                    currentUserId === message.applicationModeratorId ||
                    invites.filter(message => message.applicationId === message.appId && message.inviteModeratorId === currentUserId).length) &&
                message.isUnread && message.moderatorId !== currentUserId : true;
            }

            function filterByRead(message) {
                return messageFilters.filterMessageReadBy === null ? true : message.isUnread === !messageFilters.filterMessageReadBy
            }

            return [...new Set(this.$store.state.message.appMessages.map((message) => {
                return {
                    category: this.getDayCategory(message),
                    ...message,
                }
            }))].flat().filter(filterTextMessages).filter(filterByRead).filter(filterUnreadMessages)
        }
    },
    mounted() {
        this.finishedLoading = true
        this.isMessageModalActive = this.getActiveConversation.id !== null
    },
    watch: {},
    methods: {
        getMessageByCategory(category) {
            let filteredMessages = this.appMessages.filter((message) => message.category === category).sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))

            const uniqueMessages = [...new Set(filteredMessages.map(message => message.appId))].map(uniqMessage => {
                return filteredMessages.find(message => message.appId === uniqMessage)
            })

            // const unseenMessages = filteredMessages.filter(message => message.isUnread)
            // const compactMessages = [...new Set([...unseenMessages, ...uniqueMessages])]
            const compactMessages = [...new Set([...uniqueMessages])]

            this.menuCategoriesCount[category] = compactMessages.length

            return compactMessages
        },

        countCategories(category) {
            return this.menuCategoriesCount[category] === 0
        },

        countUnreadMesssages() {
            const unreadMessages = this.appMessages.filter((message) => message.isUnread === true && message.moderatorId !== this.currentUser.id).length
            return unreadMessages === 1 ? unreadMessages + ' unread message' : unreadMessages + ' unread messages'
        },

        getDayCategory(message) {
            var duration = moment.duration(moment(new Date()).diff(message.createdAt));
            var hours = duration.asHours();

            switch (true) {
                case (hours < 24):
                    return 'Today'

                case (hours < 48):
                    return 'Yesterday'

                case (hours < 164):
                    return 'Last Week'

                case (hours > 164):
                    return 'Older'

                default:
                    break;
            }
            return hours
        },

        messsageLabel(message) {
            return UtilService.studentName(message.studentData.personalInformation) + '' + message.user.username
        },

        isMessageUnread(message) {
            const unread = (this.$store.state.application.courseMapModerator.filter(course => course.title === message.courseTitle && course.moderatorId.includes(this.currentUser.id)).length ||
                    this.currentUser.id === message.applicationModeratorId ||
                    this.$store.state.message.invites.filter(message => message.applicationId === message.appId && message.inviteModeratorId === this.currentUser.id).length) &&
                message.isUnread && message.moderatorId !== this.currentUser.id
            const selected = this.getActiveConversation && this.getActiveConversation.id === message.appId
            return unread && selected ? 'unread selected' : unread ? 'unread' : selected ? 'selected' : ''
        },

        async showUpdates(message) {
            this.isMessageModalActive = false
            this.$store.dispatch('application/setActiveConversation', {
                id: message.appId,
                studentId: message.studentId,
                courseDocuments: message.courseDocuments,
                studentName: message.studentName,
                courseTitle: message.courseTitle,
                moderatorId: message.applicationModeratorId,
                isApproved: message.isApproved
            })

            setTimeout(() => {
                this.isMessageModalActive = true
            }, 0);
        },
    },

};
</script>

<style>
.message-modal__app {
    width: 100%;
}

.message-modal {
    width: 100%;
    height: calc(100vh - 90px);
}

.message-modal__empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.message-modal__empty img {
    width: 162px;
    margin-bottom: 20px;
}

.message_container {
    display: flex;
    background: #fff;
    margin: -20px -15px 0;
    padding: 20px 20px 0;
}

.message__parent {
    overflow: scroll;
    height: calc(100vh - 150px);
    min-width: 300px;
}

.message-holder__header {
    font-weight: bold;
    padding: 4px;
}

.message-holder__body {
    cursor: pointer;
    position: relative;

    box-shadow: 0 1px 1px rgba(0,0,0,0.15), 0 2px 2px rgba(0,0,0,0.15);
    margin: 12px 4px;
    padding: 8px;
    border-radius: 8px;
}

.message-holder__body.unread {
    background: #FFE0E0;
}

.message-holder__body.selected {
    background: rgb(10, 124, 255);
    color: white;
    border-radius: 8px;
}

.message__footer {
    position: fixed;
    bottom: 0;
    font-style: italic;
    font-size: 13px;
    width: 300px;
    padding: 12px;
    left: 0;
}

.mess_header {
    font-size: 19px;
}

.mess_body {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mess_footer {
    font-size: 13px;
}

@media only screen and (max-width: 600px) {
    .message_container {
        flex-direction: column;
    }
}
</style>
